import { fmtDate, fmtDateTime } from "@/lib/fmt";
import { TaskLine, LeadLink } from "./TaskLine";

function Burst({ g, i }) {
  return (
    <div className="mt-2 rounded bg-[var(--surface-2,rgba(127,127,127,0.06))] p-2" data-testid={`burst-group-${i}`}>
      <div className="text-xs font-medium">{g.n} tasks closed in {g.seconds < 60 ? `${g.seconds} seconds` : `${Math.round(g.seconds / 6) / 10} minutes`} · {fmtDateTime(g.start)}</div>
      {g.tasks.map((t) => <TaskLine key={t.task_id} t={t} />)}
    </div>
  );
}

function Pushed({ it }) {
  return (
    <div className="py-2 border-b border-[var(--border)] last:border-0 text-xs">
      <div className="text-sm"><LeadLink id={it.lead_id} name={it.lead_name} /> <span className="text-[var(--text-dim)]">·</span> {it.label}</div>
      <div className="text-[var(--breach)] mt-0.5">Why flagged: {it.why}</div>
      <ol className="mt-1 space-y-0.5 text-[var(--text-dim)] list-decimal ml-4">
        {it.moves.map((m, i) => <li key={i}>{fmtDateTime(m.at)}: moved from {fmtDate(m.from)} to <span className="text-[var(--text)]">{fmtDate(m.to)}</span> (+{m.days} day{m.days !== 1 ? "s" : ""})</li>)}
      </ol>
    </div>
  );
}

function Untouched({ it }) {
  return (
    <div className="py-2 border-b border-[var(--border)] last:border-0 text-xs">
      <div className="text-sm"><LeadLink id={it.lead_id} name={it.lead_name} stage={it.lead_stage} /></div>
      <div className="flex flex-wrap gap-x-4 text-[var(--text-dim)] mt-0.5">
        <span>Last touched {it.at ? fmtDateTime(it.at) : "never"}</span>
        <span>Next task: <span className="text-[var(--text)]">{it.label ? `${it.label}${it.due ? `, due ${fmtDate(it.due)}` : ""}` : "none set"}</span></span>
      </div>
      <div className="text-[var(--breach)] mt-0.5">Why flagged: {it.why}</div>
    </div>
  );
}

export function FlagCard({ f, email }) {
  const n = f.groups ? f.groups.length : f.items.length;
  return (
    <details className={`rounded border px-3 py-2 ${f.severity === "high" ? "border-[var(--breach)]" : "border-[var(--warn)]"}`} data-testid={`flag-${email}-${f.kind}`}>
      <summary className="text-sm cursor-pointer">{f.title} <span className="text-xs text-[var(--text-dim)]">· {f.severity === "high" ? "serious" : "worth checking"} · click to see all {n}</span></summary>
      {f.explain && <div className="text-xs text-[var(--text-dim)] mt-2 mb-1" data-testid={`flag-explain-${f.kind}`}>{f.explain}</div>}
      {f.groups?.map((g, i) => <Burst key={i} g={g} i={i} />)}
      {f.kind === "due_pushed" && f.items.map((it, i) => <Pushed key={i} it={it} />)}
      {f.kind === "untouched" && f.items.map((it) => <Untouched key={it.lead_id} it={it} />)}
      {["no_evidence", "overdue"].includes(f.kind) && f.items.map((t) => <TaskLine key={t.task_id} t={t} />)}
    </details>
  );
}
